import { render, staticRenderFns } from "./ValidityPeriod.vue?vue&type=template&id=6d873f80&scoped=true"
import script from "./ValidityPeriod.vue?vue&type=script&lang=js"
export * from "./ValidityPeriod.vue?vue&type=script&lang=js"
import style0 from "./ValidityPeriod.vue?vue&type=style&index=0&id=6d873f80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d873f80",
  null
  
)

export default component.exports